import React, { useState, useEffect, useContext } from "react";
import logo from "./logo.png";
import { Alert, Button, MenuItem, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Person } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { httpService } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";
import { jambDepartments, jambRoles } from "./jambData";
import Swal from "sweetalert2";

function SpecialRegistrationPage() {
  const titles = ["Prof.", "Dr.", "Mr.", "Mrs.", "Ms."];
  const { setAlertData } = useContext(AlertContext);
  const navigate = useNavigate();

  const [error, setError] = useState(false);

  const [loading, setLoading] = useState(false);

  const [participant, setParticipant] = useState({});

  const handleChange = (e) =>
    setParticipant({ ...participant, [e.target.name]: e.target.value });

  const getData = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "question",
      title: "Register",
      text: "Do you wish to submit your registration",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);

        const { data, error } = await httpService.post(
          "specialregistration",
          participant
        );

        if (data) {
          navigate(`/guestprintout/${data}`);
        }

        if (error) {
          setAlertData({ open: true, message: error, severity: "error" });
        }
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    document.title = "Registration for Invited Guests";
  }, []);
  return (
    <div style={{ minHeight: "80vh" }} className="bg-light">
      <div className="d-flex justify-content-center">
        <div className="col-lg-5 bg-white p-5 rounded shadow-sm">
          <div className="text-center mb-4">
            <img src={logo} alt="logo" width="120" height="100" />
          </div>
          <div className="text-center mb-5">
            <h4 className="text-muted" style={{ fontWeight: "700" }}>
              {new Date().getFullYear()} JAMB POLICY MEETING REGISTRATION PORTAL
              FOR INVITED GUESTS
            </h4>
          </div>
          <form onSubmit={getData}>
            <div className="mb-4">
              <TextField
                label="Title"
                select
                fullWidth
                name="title"
                onChange={handleChange}
              >
                {titles.map((c, i) => (
                  <MenuItem key={i} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div className="mb-4">
              <TextField
                fullWidth
                label="Name"
                name="name"
                onChange={handleChange}
              />
            </div>
            <div className="mb-4">
              <TextField
                fullWidth
                label="Email Address"
                name="emailAddress"
                onChange={handleChange}
              />
            </div>
            <div className="mb-4">
              <TextField
                fullWidth
                label="Designation"
                name="designation"
                onChange={handleChange}
              />
            </div>
            <div className="mb-4">
              <TextField
                fullWidth
                label="Organisation"
                name="organisation"
                onChange={handleChange}
              />
            </div>

            <div className="mb-5">
              <LoadingButton
                type="submit"
                endIcon={<Person />}
                variant="contained"
                fullWidth
                loadingPosition="end"
                disabled={error}
                loading={loading}
              >
                register
              </LoadingButton>
            </div>
          </form>
          <div className="mb-4"></div>
        </div>
      </div>
    </div>
  );
}

export default SpecialRegistrationPage;
